import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import LoadingOverlay, { LoadingOverlayProps } from "@insite/mobius/LoadingOverlay";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

const enum fields {
    loadingMessage = "loadingMessage",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.loadingMessage]: string;
    };
}

export interface LoadingStyles {
    wrapper?: InjectableCss;
    overlay?: LoadingOverlayProps;
    text?: TypographyPresentationProps;
}

export const loadingStyles: LoadingStyles = {
    wrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            align-items: center;
        `,
    },
    overlay: {
        css: css`
            min-height: 25vh;
            height: 100%;
        `,
    },
    text: {
        color: "text.disabled",
        size: 15,
    },
};

const styles = loadingStyles;

type Props = OwnProps;

const Loading: React.FC<Props> = ({ fields }) => {
    return (
        <StyledWrapper {...styles.wrapper}>
            <LoadingOverlay {...styles.overlay}></LoadingOverlay>
            <Typography {...styles.text}>{fields.loadingMessage}</Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: Loading,
    definition: {
        group: "Basic",
        fieldDefinitions: [
            {
                name: fields.loadingMessage,
                displayName: "Loading Message",
                editorTemplate: "TextField",
                defaultValue: "Please wait while you are redirected.",
                fieldType: "Translatable",
            },
        ],
    },
};

export default widgetModule;
